import { apiProxyRequest as request } from "Api/apiProxyRequest";

import type {
  CarbonEmissionsOrganizationResponse,
  GetOrganizationCarbonEmissionsParams
} from "./carbonEmissions.types";

/**
 * Get carbon emissions data for an organization
 *
 * @param organizationId - ID of the organization
 * @param from - Start date in ISO format (YYYY-MM-DD)
 * @param to - End date in ISO format (YYYY-MM-DD)
 * @param interval - Data interval (day/week/month)
 */
export const getOrganizationCarbonEmissions = ({
  organizationId,
  from,
  to,
  interval = "day"
}: GetOrganizationCarbonEmissionsParams) =>
  request<CarbonEmissionsOrganizationResponse>(
    `/organizations/${organizationId}/metrics/carbon`,
    "GET",
    { from, to, interval }
  );
